import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import ReduxFormsImageCropper from '../common/forms/ReduxFormsImageCropper';
import ReduxFormsPlacesAutocomplete from '../common/forms/ReduxFormsPlacesAutocomplete';
import CropperScaffold from '../common/forms/CropperScaffold';
import cloneDeep from 'lodash/cloneDeep';
import ReduxFormsField from '../common/forms/ReduxFormsField';
import CheckboxBoolean from '../common/forms/CheckboxBoolean';

import 'cropperjs/dist/cropper.css';

const validate = values => {
  const errors = {};
  const { availability, biography, location, name, profile_image, profile_image_id } = values;

  if (!availability || !availability.trim()) {
    errors.availability = ['Please enter your availability'];
  } else if (availability.trim().length > 255) {
    errors.availability = ['Availability cannot be longer than 255 characters'];
  }

  if (!biography || !biography.trim()) {
    errors.biography = ['Please enter a biography'];
  }

  if (!location) {
    errors.location = ['Please select a location'];
  }

  if (!name || !name.trim()) {
    errors.name = ['Please enter a name'];
  }

  if (!profile_image && !profile_image_id) {
    errors.profile_image = ['Please upload a profile image'];
  }

  return errors;
};

class MovementSpecialistEditForm extends Component {
  state = {
    clearOrigProfileImage: false,
    clearOrigHeaderImage: false,
  };

  onSubmit = values => {
    const submitValues = cloneDeep(values);

    submitValues.availability = submitValues.availability.trim();
    submitValues.biography = submitValues.biography.trim();
    submitValues.name = submitValues.name.trim();

    if (typeof submitValues.location === 'object') {
      submitValues.latitude = submitValues.location.latitude;
      submitValues.longitude = submitValues.location.longitude;
      submitValues.location_short = submitValues.location.location_short;
      submitValues.location_long = submitValues.location.location_long;
    }

    return this.props.onSubmit(submitValues);
  };

  render() {
    const {
      clearOrigProfileImage,
      clearOrigHeaderImage,
      handleSubmit,
      movementSpecialist,
      onCancel,
      removeProfileImage,
      removeHeaderImage,
      submitting,
    } = this.props;

    return (
      <div className="admin-paper__edit-content">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field name="name" component={ReduxFormsField} label="Name" required>
            <input type="text" />
          </Field>
          <Field name="biography" component={ReduxFormsField} label="Biography" required>
            <input type="text" />
          </Field>
          <Field
            name="location"
            component={ReduxFormsPlacesAutocomplete}
            label="Location"
            initialValue={movementSpecialist.get('location_long')}
            required
          />
          <Field name="availability" component={ReduxFormsField} label="Availability" required>
            <input type="text" />
          </Field>
          <Field
            name="hidden"
            component={ReduxFormsField}
            label="Hide this movement specialist from the members site?"
            required
          >
            <CheckboxBoolean />
          </Field>
          {movementSpecialist && movementSpecialist.get('profile_image_id') && !clearOrigProfileImage ? (
            <CropperScaffold label="Profile Image" required>
              <div className="original-image">
                <img alt="course logo" src={movementSpecialist.getIn(['profileImage', 'location'])} />
              </div>
              <div className="cropper-scaffold__controls">
                <button type="button" className="button button--theme--outline" onClick={removeProfileImage}>
                  Remove Profile Image
                </button>
              </div>
            </CropperScaffold>
          ) : (
            <Field name="profile_image" component={ReduxFormsImageCropper} label="Profile Image" />
          )}
          {movementSpecialist && movementSpecialist.get('header_image_id') && !clearOrigHeaderImage ? (
            <CropperScaffold label="Header Image" required>
              <div className="original-image">
                <img alt="course logo" src={movementSpecialist.getIn(['headerImage', 'location'])} />
              </div>
              <div className="cropper-scaffold__controls">
                <button type="button" className="button button--theme--outline" onClick={removeHeaderImage}>
                  Remove Header Image
                </button>
              </div>
            </CropperScaffold>
          ) : (
            <Field name="header_image" component={ReduxFormsImageCropper} label="Header Image" />
          )}
          <div className="admin-paper__edit-content__button-row flex-end">
            <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
              Cancel
            </button>
            <button type="submit" className="button" disabled={submitting}>
              Save
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'movementSpecialistEditForm',
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
  validate,
})(MovementSpecialistEditForm);



// WEBPACK FOOTER //
// ./src/movement-specialists/MovementSpecialistEditForm.js